import React from "react";
import { Button, Paper, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  container: {
    maxWidth: 600,
    margin: '50px auto',
    padding: '24px',
    borderTop: '6px solid #18cc69',
    borderRadius: '6px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    textAlign: 'center',
  },
  heading: {
    fontSize: '24px',
    fontWeight: 500,
    marginBottom: '8px',
  },
  subtext: {
    fontSize: '14px',
    color: '#555',
    marginBottom: '20px',
  },
  button: {
    marginTop: '16px',
  },
}));

const ContactUs = () => {
  const classes = useStyles();

  const handleButtonClick = () => {
    window.open('https://forms.gle/EzUoqbwo1pxedS4e7', '_blank');
  };

  return (
    <Paper className={classes.container}>
      <Typography className={classes.heading}>
        Complaint Form - ParkSmart
      </Typography>
      <Typography className={classes.subtext}>
        Feel free to let us know any issues that you're facing with our system
        and we’ll make sure to resolve those asap!
      </Typography>
      <Button
        variant="contained"
        color="primary"
        onClick={handleButtonClick}
        className={classes.button}
        disableElevation
      >
        Open Google Form
      </Button>
    </Paper>
  );
};

export default ContactUs;

// Discarded the old form
// const ContactUs = () => {
//     return (
//         <div>
//             <iframe
//                 src="https://docs.google.com/forms/d/e/1FAIpQLSfNPFCu194ELhGnPe42L4-RNW685Qt5eKVUE9bHGIdEEIwbYg/viewform?embedded=true"
//                 width="100%"
//                 frameborder="0"
//                 marginheight="0"
//                 marginwidth="0"
//                 style={{ minHeight: '500px' }}
//                 title="Google Form"
//             >
//                 Loading…
//             </iframe>
//         </div>
//     );
// };
